export default class Locales {

  static getLocaleCode(locale: string): string {
    switch (locale) {
      case "fr":
        return "fr_FR";
      case "en":
        return "en_US";
      default:
        return "fr_FR";
    }
  }
}
